<template>
  <div class="container white pa-0">
    <!-- alertas -->

    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <div v-if="showMain">
      <!-- Modal Loading -->
      <v-dialog persistent max-width="300" v-model="blockScreen">
        <v-card class="px-3 py-5 text-center">
          <div class="text-center pb-5">
            <span class="title font-weight-bold"
              >Aguarde, estamos processando os dados...</span
            >
          </div>
          <v-progress-circular
            :size="70"
            :width="7"
            class="checkin-text"
            indeterminate
          ></v-progress-circular>
        </v-card>
      </v-dialog>

      <!-- menu superior -->
      <v-layout column class="menu w-100 white">
        <v-card elevation="2" tile>
          <v-layout
            align-center
            justify-space-around
            class="py-2 px-3 colorSelectedBack sizeTop"
          >
            <img
              :src="require(`@/assets/logos/usecargobranco.png`)"
              alt="pickndrive"
              style="width: auto; height: 39px"
            />
          </v-layout>
        </v-card>
      </v-layout>

      <!-- Mudar tela -->
      <v-layout column class="changePage w-100 white">
        <v-card elevation="2" tile>
          <v-layout align-center justify-space-around class="px-3">
            <v-btn
              text
              :class="showNewRequests ? 'colorSelected' : 'grey--text'"
              @click="changePage('new')"
            >
              <span class="subheading font-weight-medium">Reservas</span>
            </v-btn>
            <v-divider vertical class="ma-0"></v-divider>
            <v-btn
              text
              :class="showOldRequests ? 'colorSelected' : 'grey--text'"
              @click="changePage('old')"
            >
              <span class="subheading font-weight-medium">Histórico</span>
            </v-btn>
          </v-layout>
        </v-card>
      </v-layout>

      <div style="height: 96px"></div>

      <!-- modal cancelar -->
      <v-dialog v-model="modalCancel">
        <v-card class="pa-4 text-center">
          <span class="title font-weight-bold"
            >Tem certeza que deseja cancelar a reserva?</span
          >
          <v-flex xs12>
            <v-textarea
              rows="8"
              outline
              hide-details
              color="grey darken-2"
              label="Motivo do cancelamento"
              class="pt-4 pb-3 px-2"
              v-model="motiveCancel"
            ></v-textarea>
          </v-flex>
          <v-flex row class="font-weight-regular ma-0">
            <v-btn text class="btn-error" @click="modalCancel = !modalCancel"
              >NÃO</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!motiveCancel"
              class="btn-sucess white--text"
              @click="cancelVehicleRequest()"
              >SIM</v-btn
            >
          </v-flex>
        </v-card>
      </v-dialog>

      <!-- modal sair da reserva -->
      <v-dialog v-model="modalRemovePassenger">
        <v-card class="pa-4 text-center">
          <span class="title font-weight-bold"
            >Tem certeza que deseja sair da reserva?</span
          >
          <br />
          <v-flex row class="font-weight-regular ma-0">
            <v-btn
              text
              class="btn-error"
              @click="modalRemovePassenger = !modalRemovePassenger"
              >NÃO</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!modalRemovePassenger"
              class="btn-sucess white--text"
              @click="removePassengerFunction()"
              >SIM</v-btn
            >
          </v-flex>
        </v-card>
      </v-dialog>

      <!-- pagina de reservas -->
      <div v-if="showNewRequests" class="newRequest py-3 px-2">
        <!-- <ModalFuel
          :show="modalAbastecer"
          :vehicleInfo="abastecerId"
          @close="modalAbastecer = false"
        ></ModalFuel> -->
        <v-btn
          style="z-index: 1"
          fab
          @click="openChat()"
          class="colorBtn floatBtn"
        >
          <v-icon>chat</v-icon>
        </v-btn>

        <!-- se houver reserva ativa -->
        <v-card v-if="requestsInCheckout" class="mx-2 px-2 py-4 moment">
          <v-layout column>
            <span class="title text-center text--darken-1 mb-2"
              >Reserva atual:</span
            >
            <v-alert
              :value="true"
              type="warning"
              class="w-100"
              outline
              dismissible
              v-if="warningMomentRequest"
              >Você está atrasado para fazer o check-out.</v-alert
            >
            <div style="margin: 10px">
              <div class="contentLeft">
                <span class="modelo">{{
                  requestsInCheckout.vehicle.vehicle_model.model
                }}</span>
                <br />
                <img
                  class="vehicleImg"
                  style="max-width: 186px; height: auto"
                  :src="
                    `${url_bucket}${requestsInCheckout.vehicle.vehicle_model.url}`
                  "
                />
                <br />
                <span class="body-1 total">Placa:</span>
                <span class="pl-2 body-1 total">{{
                  requestsInCheckout.vehicle.plate
                }}</span>
                <br />
              </div>
              <div class="contentRight pt-2 pl-2">
                <div class="pb-1">
                  <img src="../../assets/icons/icon2.png" />
                  <span class="pl-2 caption">{{
                    requestsInCheckout.vehicle.gearbox ? 'Automático' : 'Manual'
                  }}</span>
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon3.png" />
                  <span class="pl-2 caption">Flex</span>
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon4.png" />
                  <span class="pl-2 caption"
                    >{{ requestsInCheckout.vehicle.doors_qtd }} Portas</span
                  >
                </div>
                <div class="pb-1">
                  <img src="../../assets/icons/icon5.png" />
                  <span class="pl-2 caption">Ar<br />Condicionado</span>
                </div>
              </div>
            </div>
            <v-divider
              v-if="user == requestsInCheckout.user.id"
              class="mb-3 mt-0 mx-4"
            ></v-divider>
            <v-layout class="px-4" column>
              <v-layout
                v-if="user == requestsInCheckout.user.id"
                justify-space-between
              >
                <span class="font-weight-bold">Check-in:</span>
                <span class="font-weight-regular">{{
                  requestsInCheckout.begin_date | normalizeDate
                }}</span>
              </v-layout>
              <v-layout
                v-if="user == requestsInCheckout.user.id"
                class="pt-2"
                justify-space-between
              >
                <span class="font-weight-bold">Check-out:</span>
                <span class="font-weight-regular">{{
                  requestsInCheckout.end_date | normalizeDate
                }}</span>
              </v-layout>
            </v-layout>
            <v-divider
              v-if="user == requestsInCheckout.user.id"
              class="my-2 mx-4"
            ></v-divider>
            <div class="text-center">
              <b-row
                v-if="
                  user == requestsInCheckout.user.id &&
                    requestsInCheckout.shared_request
                "
                align-h="center"
                align-v="center"
                class="mt-3"
              >
                <span
                  style="
                    padding: 15px;
                    margin-bottom: 20px;
                    font-size: 10px;
                    text-align: justify;
                    display: block;
                  "
                  >Reserva para o motorista
                  <strong>{{ requestsInCheckout.user.name }}</strong> ({{
                    requestsInCheckout.user.email
                  }}) faça o seu Check-out e de outros
                  {{ requestsInCheckout.request_user_group.length }}
                  passageiros, da sua viagem saindo de
                  {{
                    requestsInCheckout.shared_vehicle_request.point_begin
                      .point_address.address_format
                  }}
                  ({{
                    requestsInCheckout.shared_vehicle_request.point_begin.name
                  }}) no dia
                  {{ requestsInCheckout.begin_date | normalizeDay }} às
                  {{ requestsInCheckout.begin_date | normalizeTime }}, com
                  retorno de
                  {{
                    requestsInCheckout.shared_vehicle_request.point_end
                      .point_address.address_formatte
                  }}
                  ({{
                    requestsInCheckout.shared_vehicle_request.point_end.name
                  }}) no dia {{ requestsInCheckout.end_date | normalizeDay }} às
                  {{ requestsInCheckout.end_date | normalizeTime }}
                </span>
              </b-row>

              <b-row style="justify-content: center">
                <div>
                  <div>
                    <v-btn
                      v-if="
                        requestsInCheckout.shared_request &&
                          user != requestsInCheckout.user.id
                      "
                      @click="
                        sharedRequestPassagers(
                          requestsInCheckout.user.name,
                          requestsInCheckout.request_user_group
                        )
                      "
                      class="passageiroBtn"
                      large
                      outlined
                      color="primary"
                    >
                      <b style="font-size: 10px">PASSAGEIROS</b>
                    </v-btn>
                  </div>
                </div>
              </b-row>
            </div>
            <v-btn
              v-if="user == requestsInCheckout.user.id"
              @click="checkSchedule()"
              large
              color="white"
              class="btnGroup"
              >PRORROGAR CHECK-OUT</v-btn
            >

            <v-btn
              v-if="
                requestsInCheckout.vehicle.card_password &&
                  user == requestsInCheckout.user.id
              "
              @click="
                $router.push({
                  name: 'vehicle-request-refuel',
                  params: {
                    vehicleRequestId: requestsInCheckout.id,
                  },
                })
              "
              large
              color="white"
              class="btnGroup"
              >ABASTECER
            </v-btn>

            <v-divider
              v-if="user == requestsInCheckout.user.id"
              class="my-2"
            ></v-divider>
            <v-btn
              v-if="user == requestsInCheckout.user.id"
              @click="goToCheck(requestsInCheckout.id)"
              large
              class="checkout white--text btnGroup"
              >FAZER CHECK-OUT</v-btn
            >
            <!-- <v-btn @click="openDoors(requestsInCheckout.id)" large class="btnColor white--text">Abrir portas</v-btn> -->
            <!-- <v-btn
              :disabled="dialog"
              :loading="dialog"
              class="white--text"
              color="purple darken-2"
              @click="dialog = true"
            > -->
            <v-row justify="center">
              <v-btn
                v-if="user == requestsInCheckout.user.id"
                ma-3
                :disabled="dialog"
                :loading="dialog"
                @click="
                  openDoors(requestsInCheckout.vehicle.id);
                  dialog = true;
                "
                class="btnGroup pr-3"
                text
              >
                ABRIR PORTAS
              </v-btn>

              <v-btn
                v-if="user == requestsInCheckout.user.id"
                ma-3
                :disabled="dialog"
                :loading="dialog"
                @click="
                  closeDoors(requestsInCheckout.vehicle.id);
                  dialog = true;
                "
                class="btnGroup pr-3"
                text
              >
                FECHAR PORTAS
              </v-btn>
            </v-row>

            <v-dialog v-model="dialog" hide-overlay persistent width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Aguarde, enviando comando...
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-card>

        <!-- se não houver reservas ativas ou futuras-->
        <v-card
          min-height="180px"
          class="mx-2 px-2 py-4 bottom"
          v-if="
            requestsInCheckIn.length == 0 &&
              !requestsInCheckout &&
              passageiroInCheckIn.length == 0 &&
              passageiroInCheckOut.length == 0
          "
        >
          <v-layout column class="text-center">
            <span class="title text-center grey--text text--darken-1 px-4"
              >Nenhuma reserva ativa ou futura</span
            >
            <v-icon class="icon-size py-4">alarm_off</v-icon>
            <v-btn
              large
              class="btnColor mx-5 px-0"
              @click="$router.push('/user/solicitar-reserva')"
            >
              <span class="white--text font-weight-medium"
                >FAZER NOVA RESERVA</span
              >
            </v-btn>
          </v-layout>
        </v-card>

        <v-layout
          column
          class="text-center pb-5"
          v-if="requestsInCheckIn.length != 0"
        >
          <v-btn large text class="btnInfo mx-5 px-8" @click="info()">
            <v-icon class="py-4" color="#016EA7"
              >mdi-alert-circle-outline</v-icon
            >
            <!--<img class="float-left" src="../../assets/icons/back.png" />-->
            <span class="text-center font-weight-medium pr-4 pl-2"
              >Informações da reserva
            </span>
            <img class="float-right" src="../../assets/icons/advance.png" />
          </v-btn>
        </v-layout>

        <!-- se houver reservas futuras -->
        <v-card
          v-if="requestsInCheckIn.length > 0"
          min-height="180px"
          class="mx-2 px-2 py-4 bottom"
        >
          <v-layout column>
            <div>
              <span class="text-center title grey--text text--darken-1 mb-2"
                >Reserva(s) futura(s):</span
              >
            </div>
            <!-- para cada reserva futura -->
            <v-layout
              column
              justify-center
              v-for="(items, index) in requestsInCheckIn"
              :key="index"
            >
              <v-card text class="vehicle mb-2 mt-3 pa-3">
                <div class="infoVehicle">
                  <span
                    style="font-weight: bold; color: #016ea7"
                    class="text-center"
                  >
                    {{ items.vehicle.vehicle_model.model }}
                    - {{ items.vehicle.vehicle_model.brand }}</span
                  >
                  <br />
                  <span style="color: #016ea7" class="text-center color: white;"
                    >Placa:{{ items.vehicle.plate }}</span
                  >
                  <br />
                  <img
                    class="vehicleImg"
                    style="max-width: 186px; height: auto"
                    :src="`${url_bucket}${items.vehicle.vehicle_model.url}`"
                  />
                  <div class="pt-2 pl-2">
                    <img src="../../assets/icons/icon2.png" />
                    <span class="pl-2 caption">{{
                      items.vehicle.gearbox ? 'Automático' : 'Manual'
                    }}</span>
                    &nbsp;
                    <img src="../../assets/icons/icon3.png" />
                    <span class="pl-2 caption">Flex</span>
                    &nbsp;
                    <img src="../../assets/icons/icon4.png" />
                    <span class="pl-2 caption"
                      >{{ items.vehicle.doors_qtd }} Portas</span
                    >
                    &nbsp;
                    <img src="../../assets/icons/icon5.png" />
                    <span class="pl-2 caption">Ar Cond.</span>
                  </div>
                  <br />
                  <b-row
                    v-if="items.shared_request"
                    align-h="center"
                    align-v="center"
                    class="mt-3"
                  >
                    <span
                      style="
                        font-size: 10px;
                        text-align: justify;
                        display: block;
                      "
                    >
                      Reserva para o motorista
                      <strong>{{ items.user.name }}</strong> ({{
                        items.user.email
                      }}) faça o seu Check-in e de outros
                      {{ items.request_user_group.length }}
                      passageiros, da sua viagem saindo de
                      {{
                        items.shared_vehicle_request.point_begin.point_address
                          .address_format
                      }}
                      ({{ items.shared_vehicle_request.point_begin.name }}) no
                      dia {{ items.begin_date | normalizeDay }} às
                      {{ items.begin_date | normalizeTime }}, com retorno de
                      {{
                        items.shared_vehicle_request.point_end.point_address
                          .address_formatte
                      }}
                      ({{ items.shared_vehicle_request.point_end.name }}) no dia
                      {{ items.end_date | normalizeDay }} às
                      {{ items.end_date | normalizeTime }}
                    </span>
                  </b-row>
                </div>
              </v-card>
              <v-divider
                v-if="!items.shared_request"
                class="my-3 mx-4"
              ></v-divider>
              <v-layout class="px-4" column>
                <v-layout v-if="!items.shared_request" justify-space-between>
                  <span class="checkin-text font-weight-bold">Check-in:</span>
                  <span class="total font-weight-regular">{{
                    items.begin_date | normalizeDate
                  }}</span>
                </v-layout>
                <v-layout
                  v-if="!items.shared_request"
                  class="pt-2"
                  justify-space-between
                >
                  <span class="checkout-text font-weight-bold">Check-out:</span>
                  <span class="total font-weight-regular">{{
                    items.end_date | normalizeDate
                  }}</span>
                </v-layout>
              </v-layout>
              <v-divider
                v-if="!items.shared_request"
                class="my-3 mx-4"
              ></v-divider>
              <b-row
                v-if="items.shared_request"
                style="justify-content: center"
              >
                <div>
                  <div>
                    <v-btn
                      v-if="items.shared_request && user == items.user.id"
                      @click="goToCheck(items.id)"
                      class="passageiroBtn"
                      large
                      color="primary"
                      :disabled="!items.allowCheckIn"
                      ><b style="font-size: 10px">FAZER CHECK-IN</b></v-btn
                    >
                  </div>
                  <div>
                    <v-btn
                      v-if="items.shared_request"
                      @click="
                        sharedRequestPassagers(
                          items.user.name,
                          items.request_user_group
                        )
                      "
                      class="passageiroBtn"
                      large
                      outlined
                      color="primary"
                    >
                      <b style="font-size: 10px">PASSAGEIROS</b>
                    </v-btn>
                  </div>
                </div>
              </b-row>
              <v-btn
                v-if="!items.shared_request && user == items.user.id"
                @click="goToCheck(items.id)"
                large
                class="checkin white--text btnGroup"
                :disabled="!items.allowCheckIn"
                >FAZER CHECK-IN</v-btn
              >
              <v-btn
                @click="checkTimeCancel(items.id)"
                v-if="cancelTime && user == items.user.id"
                large
                text
                class="btnGroup"
                >CANCELAR RESERVA</v-btn
              >
            </v-layout>
          </v-layout>
          <div
            v-if="requestsInCheckot && user != items.user.id"
            class="notification"
          >
            O MOTORISTA JÁ CONFIRMOU A RESERVA
          </div>
        </v-card>

        <!-- se houver reservas passageiro -->
        <v-card
          v-if="passageiroInCheckIn.length > 0"
          min-height="180px"
          class="mx-2 px-2 py-4 bottom"
        >
          <v-layout column>
            <div>
              <span class="text-center title grey--text text--darken-1 mb-2"
                >Reserva(s) futura(s):</span
              >
              <div class="info">
                <v-tooltip bottom color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      x-small
                      dark
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <b>?</b>
                    </v-btn>
                  </template>
                  <span
                    >Apenas o motorista poderá confirmar o Check-in. Após o
                    mesmo confirmar, a reserva não poderá mais ser
                    cancelada.</span
                  >
                </v-tooltip>
              </div>
            </div>
            <!-- para cada reserva futura -->
            <v-layout
              column
              justify-center
              v-for="(items, index) in passageiroInCheckIn"
              :key="index"
            >
              <v-card text class="vehicle mb-2 mt-3 pa-3">
                <div class="infoVehicle">
                  <span
                    style="font-weight: bold; color: #016ea7"
                    class="text-center"
                  >
                    {{ items.vehicle.vehicle_model.model }}
                    - {{ items.vehicle.vehicle_model.brand }}</span
                  >
                  <br />
                  <span style="color: #016ea7" class="text-center color: white;"
                    >Placa:{{ items.vehicle.plate }}</span
                  >
                  <br />
                  <img
                    class="vehicleImg"
                    style="max-width: 186px; height: auto"
                    :src="`${url_bucket}${items.vehicle.vehicle_model.url}`"
                  />
                  <div class="pt-2 pl-2">
                    <img src="../../assets/icons/icon2.png" />
                    <span class="pl-2 caption">{{
                      items.vehicle.gearbox ? 'Automático' : 'Manual'
                    }}</span>
                    &nbsp;
                    <img src="../../assets/icons/icon3.png" />
                    <span class="pl-2 caption">Flex</span>
                    &nbsp;
                    <img src="../../assets/icons/icon4.png" />
                    <span class="pl-2 caption"
                      >{{ items.vehicle.doors_qtd }} Portas</span
                    >
                    &nbsp;
                    <img src="../../assets/icons/icon5.png" />
                    <span class="pl-2 caption">Ar Cond.</span>
                  </div>
                  <br />
                  <b-row
                    v-if="items.shared_request"
                    align-h="center"
                    align-v="center"
                    class="mt-3"
                  >
                    <span
                      style="
                        font-size: 10px;
                        text-align: justify;
                        display: block;
                      "
                      >Reserva para o motorista
                      <strong
                        >{{ items.user.name }} ( Email: {{ items.user.email }},
                        Telefone: {{ items.user.phone | formatPhone }} )</strong
                      >
                      faça o seu Check-in e de outros
                      {{ items.request_user_group.length }}
                      passageiros, da sua viagem saindo de
                      {{
                        items.shared_vehicle_request.point_begin.point_address
                          .address_format
                      }}
                      ({{ items.shared_vehicle_request.point_begin.name }}) no
                      dia {{ items.begin_date | normalizeDay }} às
                      {{ items.begin_date | normalizeTime }}, com retorno de
                      {{
                        items.shared_vehicle_request.point_end.point_address
                          .address_formatte
                      }}
                      ({{ items.shared_vehicle_request.point_end.name }}) no dia
                      {{ items.end_date | normalizeDay }} às
                      {{ items.end_date | normalizeTime }}
                    </span>
                  </b-row>
                </div>
              </v-card>
              <v-divider
                v-if="!items.shared_request"
                class="my-3 mx-4"
              ></v-divider>
              <v-layout class="px-4" column>
                <v-layout v-if="!items.shared_request" justify-space-between>
                  <span class="checkin-text font-weight-bold">Check-in:</span>
                  <span class="total font-weight-regular">{{
                    items.begin_date | normalizeDate
                  }}</span>
                </v-layout>
                <v-layout
                  v-if="!items.shared_request"
                  class="pt-2"
                  justify-space-between
                >
                  <span class="checkout-text font-weight-bold">Check-out:</span>
                  <span class="total font-weight-regular">{{
                    items.end_date | normalizeDate
                  }}</span>
                </v-layout>
              </v-layout>
              <v-divider
                v-if="!items.shared_request"
                class="my-3 mx-4"
              ></v-divider>
              <b-row
                v-if="items.shared_request"
                style="justify-content: center"
              >
                <div>
                  <div>
                    <v-btn
                      v-if="items.shared_request"
                      @click="
                        openModalRemovePassenger(
                          items.id,
                          items.request_user_group[0].user_id
                        )
                      "
                      class="passageiroBtn"
                      large
                      color="primary"
                      :disabled="items.step.code == 'check-out'"
                      ><b style="font-size: 10px">CANCELAR RESERVA</b></v-btn
                    >
                  </div>
                  <div>
                    <v-btn
                      v-if="items.shared_request"
                      @click="
                        sharedRequestPassagers(
                          items.user.name,
                          items.request_user_group
                        )
                      "
                      class="passageiroBtn"
                      large
                      outlined
                      color="primary"
                    >
                      <b style="font-size: 10px">PASSAGEIROS</b>
                    </v-btn>
                  </div>
                </div>
              </b-row>
            </v-layout>
          </v-layout>
        </v-card>
      </div>

      <!-- pagina de historico -->
      <div v-if="showOldRequests" class="oldRequest py-3 px-2">
        <!-- se não houver reservas antigas-->
        <v-card class="mx-2 px-2 py-4" v-if="!haveOldRequest">
          <v-layout column class="text-center">
            <span class="title grey--text text--darken-1 px-4"
              >Nenhuma reserva antiga</span
            >
            <v-icon class="icon-size py-4">alarm_off</v-icon>
            <v-btn
              large
              class="btnColor mx-5 px-0"
              @click="$router.push('/user/newVR')"
            >
              <span class="white--text font-weight-medium"
                >FAZER NOVA RESERVA</span
              >
            </v-btn>
          </v-layout>
        </v-card>

        <div v-if="haveOldRequest" class="bottom">
          <!-- para cada reserva antiga-->
          <v-card
            v-for="(items, index) in vehicleRequests"
            :key="index"
            class="mx-2 mb-2 px-2 pt-2 py-3"
          >
            <v-layout column justify-center>
              <v-layout px-2 column>
                <v-layout class="pt-2" justify-space-between>
                  <span class="total subheading font-weight-bold"
                    >{{ items.vehicle.vehicle_model.model }} -
                    {{ items.vehicle.plate }}</span
                  >
                  <v-btn
                    v-if="cancelledItem(items)"
                    @click="openDetails(items)"
                    icon
                    class="float mt-2"
                    ><v-icon>info</v-icon></v-btn
                  >
                  <span
                    v-if="!cancelledItem(items)"
                    class="error--text subheading font-weight-bold"
                    >CANCELADA</span
                  >
                  <span
                    v-if="finishedItem(items)"
                    class="blue--text subheading font-weight-bold pr-6 pt-2"
                    >CONCLUÍDA</span
                  >
                </v-layout>
                <v-layout
                  v-if="
                    items.vehicleRequestStep[0] &&
                      items.vehicleRequestStep[0].cancel_date
                  "
                  class="pt-3"
                  justify-space-between
                >
                  <span class="total font-weight-bold">Cancelada em:</span>
                  <span class="total font-weight-regular">{{
                    items.vehicleRequestStep[0].cancel_date | normalizeDate
                  }}</span>
                </v-layout>
                <v-layout class="pt-3" justify-space-between>
                  <span class="total font-weight-bold">Check-in:</span>
                  <span class="total font-weight-regular">{{
                    items.begin_date | normalizeDate
                  }}</span>
                </v-layout>
                <v-layout class="pt-2" justify-space-between>
                  <span class="total font-weight-bold">Check-out:</span>
                  <span class="total font-weight-regular">{{
                    items.end_date | normalizeDate
                  }}</span>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-card>
          <Observer v-on:intersect="intersected"></Observer>
        </div>

        <v-dialog v-model="infoRequest">
          <detail
            v-if="infoRequest"
            :vehicleRequest="vehicleRequestsDetail"
            @changeDialog="changeDialog()"
          />
        </v-dialog>
      </div>
      <payment
        :showModal="showModalCreditCard"
        :showClose="false"
        @close="close()"
        @alert="mensagemAlerta($event)"
      ></payment>

      <v-dialog width="400px" persistent v-model="modalExtension">
        <v-card class="py-3" width="400" :height="allowed ? '525' : '230'">
          <v-btn icon class="float" @click="extensionStep(3)">
            <v-icon color="black">close</v-icon>
          </v-btn>
          <v-layout
            column
            align-center
            justify-center
            text-center
            class="headline font-weight-bold py-4"
          >
            <span>ALTERAR CHECK-OUT</span>
            <span> </span>
          </v-layout>

          <div v-if="allowed">
            <div v-if="this.nextCheckin != null" class="card-padding">
              <span> Carro disponível pra check-out até às</span>
              <span class="h5 fontPrimary"> {{ this.nextCheckin }}</span>
            </div>

            <div v-if="SelectedDate">
              <v-date-picker
                class="fontSecondary"
                :min="checkoutDate"
                title="Novo horário de check-out:"
                :reactive="true"
                width="100%"
                locale="pt-br"
                @input="dateInput = false"
                v-model="NewCheckout.date"
              >
              </v-date-picker>
            </div>

            <div v-else>
              <v-time-picker
                class="fontSecondary"
                :allowed-minutes="allowedStep"
                full-width
                format="24hr"
                locale="pt-br"
                v-model="NewCheckout.hours"
                @input="allowContinue = true"
              >
              </v-time-picker>
            </div>
            <div v-if="SelectedDate" class="rightButtons">
              <v-btn
                class="fontSecondary font-weight-bold"
                text
                :disabled="dateInput"
                @click="extensionStep(1)"
                >PRÓXIMO</v-btn
              >
            </div>

            <div v-else class="rightButtons">
              <v-btn
                class="fontSecondary font-weight-bold"
                text
                @click="extensionStep(3)"
                >CANCELAR</v-btn
              >
              <v-btn
                class="fontSecondary font-weight-bold"
                text
                :disabled="!allowContinue"
                @click="extensionStep(2)"
                >OK</v-btn
              >
            </div>
          </div>
          <div v-else>
            <v-layout column align-center justify-center text-center>
              <div class="pb-6 pt-6">
                A prorrogação do check-out não está disponível para essa
                reserva.
              </div>

              <v-btn
                width="300"
                @click="modalExtension = false"
                class="backgroundPrimary"
                >OK</v-btn
              >
            </v-layout>
          </div>
        </v-card>
      </v-dialog>
    </div>

    <div v-if="showNewDetails">
      <v-dialog persistent max-width="300" v-model="blockScreen">
        <v-card class="px-3 py-5 text-center">
          <div class="text-center pb-5">
            <span class="title font-weight-bold"
              >Aguarde, estamos processando os dados...</span
            >
          </div>
          <v-progress-circular
            :size="70"
            :width="7"
            class="checkin-text"
            indeterminate
          ></v-progress-circular>
        </v-card>
      </v-dialog>
      <v-layout column class="menu w-100 white">
        <v-card elevation="2" tile>
          <v-layout
            align-center
            justify-space-around
            class="py-2 px-3 colorSelectedBack sizeTop"
          >
            <img
              :src="require(`@/assets/logos/usecargobranco.png`)"
              alt="pickndrive"
              style="width: auto; height: 39px"
            />
          </v-layout>
        </v-card>
      </v-layout>
      <div class="y-spacing">
        <div class="title text-center text--darken-1">
          Detalhes da prorrogação:
        </div>

        <v-flex>
          <VehicleInformations
            :model="requestsInCheckout.vehicle.vehicle_model.model"
            :url="
              requestsInCheckout.vehicle.vehicle_model.url
                ? requestsInCheckout.vehicle.vehicle_model.url
                : 'VIRTUS_AZUL.png'
            "
            :plate="requestsInCheckout.vehicle.plate"
            :gearbox="requestsInCheckout.vehicle.gearbox"
            :doors_qtd="requestsInCheckout.vehicle.doors_qtd"
          ></VehicleInformations>
        </v-flex>
        <v-divider></v-divider>
        <v-layout justify-space-between>
          <span class="defaultPadding font-weight-bold">Check-out: </span>
          <span class="pr-3">
            {{ requestsInCheckout.end_date | normalizeDate }}
          </span>
        </v-layout>
        <v-layout justify-space-between>
          <span class="pt-1 defaultPadding font-weight-bold">
            Novo Check-out:
          </span>
          <span class="pt-1 pr-3">
            {{ NewCheckout.date_hour | normalizeDate }}
          </span>
        </v-layout>

        <v-divider></v-divider>
        <v-flex class="d-flex justify-content-center">
          <v-btn
            large
            width="80%"
            text
            class="checkout white--text btnGroup"
            @click="extendReservation()"
          >
            CONFIRMAR PRORROGAÇÃO</v-btn
          >
        </v-flex>

        <v-flex class="d-flex justify-content-center">
          <v-btn large width="80%" class="btnGroup" @click="showDetails()"
            >CANCELAR</v-btn
          >
        </v-flex>
      </div>
    </div>
    <!-- Modal as portas fecharam -->
    <modal
      :showModal="lockCar"
      :ifTitle="true"
      :Title="'As portas do carro abriram/trancaram?'"
      :ifIcon="true"
      :Icon="'lock'"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="openModalBluetooth"
      @btnDois="lockCar = false"
    ></modal>

    <!-- Modal bluetooth -->
    <modal
      :showModal="dialogBluetooth"
      :ifSubheadingTop="true"
      :SubheadingTop="'Deseja abrir as portas com o bluetooth do seu aparelho?'"
      :ifTitle="true"
      :Title="'Gostaria de tentar utilizando o bluetooth?'"
      :ifIcon="true"
      :Icon="'bluetooth'"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="dialogBluetooth = false"
      @btnDois="openBluetoothPage()"
    ></modal>

    <div>
      <!-- MODAL PASSAGEIROS -->
      <v-dialog v-model="dialogPassageiro" max-width="300px" persistent>
        <v-card class="pa-4 pt-5">
          <v-layout column>
            <div class="text-center title grey--text text--darken-1 mb-2">
              <b>Passageiros</b>
            </div>
            <div class="passageiros">
              <div v-if="this.driver != null" class="passageirosDiv">
                <img
                  class="passageirosImg"
                  src="../../assets/icons/volante.png"
                />{{ this.driver.substr(0, 13) }}
                <span class="text-center grey--text passageirosDesc">
                  &nbsp; (Motorista)</span
                >
              </div>
              <div v-if="passagers[0] != null" class="passageirosDiv">
                <img
                  class="passageirosImg"
                  src="../../assets/icons/profile.png"
                />{{ passagers[0].user.name.substr(0, 13) }}
                <span class="text-center grey--text passageirosDesc">
                  &nbsp; (Passageiro)</span
                >
              </div>
              <div v-if="passagers[1] != null" class="passageirosDiv">
                <img
                  class="passageirosImg"
                  src="../../assets/icons/profile.png"
                />{{ passagers[1].user.name.substr(0, 13) }}
                <span class="text-center grey--text passageirosDesc">
                  &nbsp; (Passageiro)</span
                >
              </div>
              <div v-if="passagers[2] != null" class="passageirosDiv">
                <img
                  class="passageirosImg"
                  src="../../assets/icons/profile.png"
                />{{ passagers[2].user.name.substr(0, 13) }}
                <span class="text-center grey--text passageirosDesc">
                  &nbsp; (Passageiro)</span
                >
              </div>
              <div v-if="passagers[3] != null" class="passageirosDiv">
                <img
                  class="passageirosImg"
                  src="../../assets/icons/profile.png"
                />{{ passagers[3].user.name.substr(0, 13) }}
                <span class="text-center grey--text passageirosDesc">
                  &nbsp; (Passageiro)</span
                >
              </div>
            </div>

            <div class="text-center">
              <v-btn
                class="btnDialog"
                @click="dialogPassageiro = false"
                large
                color="primary"
              >
                <b>OK, ENTENDI</b>
              </v-btn>
            </div>
          </v-layout>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import theming from '../../mixins/theming';
import UserController from '../../controllers/UserController';
import VehicleRequest from '../../controllers/VehicleRequestController.js';
import User from './../../models/User.js';
import modal from '../shared/ModalPadrao.vue';
import detail from '../user/VehicleRequestDatail.vue';
import moment from 'moment';
import VehicleController from './../../controllers/VehicleController.js';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import ConfigurationController from '../../controllers/ConfigurationController.js';
import CreditCardController from '../../controllers/UserCreditCardController';
import ExtensionController from '../../controllers/ReservationExtensionController.js';
import Constants from '../../models/constants/Constants';
import Observer from '../shared/Observer';
import payment from './ModalPayment.vue';
import Information from '../shared/ReservationInformation.vue';
import VehicleInformations from '../shared/VehicleInformations';

export default {
  mixins: [theming],

  components: {
    modal,
    detail,
    Observer,
    payment,
    Information,
    VehicleInformations,
  },

  async created() {
    this.blockScreen = true;
    await this.getConfigurations();
    await this.getAllVehicleRequests();
    this.blockScreen = false;
    window.setInterval(() => {
      this.getRequestInCheckIn();
    }, 60000);
    await this.getUser();
    await this.getRequestPassagers();
  },

  filters: {
    money(str) {
      str = 'R$ ' + parseFloat(str / 100).toFixed(2);
      return str.replace('.', ',');
    },
    normalizeDate(date) {
      moment.locale('pt-Br');
      return moment(date).format('DD[/]MM[/]YYYY [-] HH:mm');
    },
    normalizeDay(date) {
      moment.locale('pt-Br');
      return moment(date).format('DD[/]MM');
    },
    normalizeTime(date) {
      moment.locale('pt-Br');
      return moment(date).format('HH:mm');
    },
    formatPhone(phone) {
      if (phone) return phone.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    },
  },

  data() {
    return {
      cards: [],
      checkoutDate: '00:00',
      cardId: null,
      requestAdditionalValue: null,
      nextCheckin: null,
      allowContinue: false,
      SelectedDate: true,
      dateInput: true,
      NewCheckout: {},
      showMain: true,
      showNewDetails: false,
      allowed: true,
      modalExtension: false,
      blockScreen: false,
      showNewRequests: true,
      showOldRequests: false,
      haveMomentRequest: true,
      haveFutureRequest: true,
      warningMomentRequest: false,
      cancelTime: true,
      haveOldRequest: true,
      infoRequest: false,
      value: 4,
      userController: new UserController(this.$resource),
      VehicleRequestResource: new VehicleRequest(this.$resource),
      vehicleController: new VehicleController(this.$resource),
      vehicleRequestController: new VehicleRequestController(this.$resource),
      configurationController: new ConfigurationController(this.$resource),
      creditCardController: new CreditCardController(this.$resource),
      ExtensionController: new ExtensionController(this.$resource),
      configurations: {},
      user: new User(),
      modalComplete: false,
      vehicleRequests: [],
      vehicleRequestsNext: {
        page: 1,
        limit: 5,
      },
      requestsInCheckout: null,
      requestsInCheckIn: [],
      modalCancel: false,
      motiveCancel: '',
      cancelId: null,
      vehicleRequestsDetail: null,
      dialog: false,
      responseDoors: {},
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      modalAbastecer: false,
      abastecerId: {},
      showModalCreditCard: false,
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
      client_id: localStorage.getItem('client_id'),
      lockCar: false,
      dialogBluetooth: false,
      passagers: [],
      driver: null,
      dialogPassageiro: false,
      sharedRequest: true,
      passageiroInCheckIn: [],
      passageiroInCheckOut: [],
      passageiro: [],
      removePassenger: {},
      modalRemovePassenger: false,
    };
  },
  watch: {
    dialog(val) {
      if (!val) return;

      setTimeout(() => {
        this.dialog = false;

        this.responseDoors.ok
          ? this.$awn.success(this.responseDoors.mensagem)
          : this.$awn.alert(this.responseDoors.mensagem);

        this.lockCar = true;
      }, 7000);
    },
  },

  methods: {
    openBluetoothPage() {
      this.$router.push({
        path: `/user/reserva/${this.requestsInCheckout.vehicle.id}/bluetooth`,
      });
    },
    openModalBluetooth() {
      this.lockCar = false;
      if (
        this.requestsInCheckout.vehicle.bluetooth_mac_address &&
        this.requestsInCheckout.vehicle.bluetooth_device_name
      )
        this.dialogBluetooth = true;
    },
    extensionStep(step) {
      //Proxima tela = horas
      if (step == 1) {
        this.dateInput = true;
        this.SelectedDate = false;
        this.allowContinue = false;
      } else if (step == 2) {
        //Proxima tela = confirmação

        var date = this.NewCheckout.date;
        var hour = this.NewCheckout.hours;
        this.NewCheckout.date_hour = date + ' ' + hour + ':00';
        //se Data + Hora for menor que a data de checkout original
        if (this.NewCheckout.date_hour <= this.requestsInCheckout.end_date) {
          this.alert('Data menor ou igual a data de Check-out!', 'error');
        } else {
          this.additionalValue();
          this.showDetails();
        }
      } else {
        //Cancelar e reverter
        this.modalExtension = false;
        this.SelectedDate = true;
        this.allowContinue = false;
      }
    },

    showDetails() {
      this.showMain = !this.showMain;
      this.showNewDetails = !this.showNewDetails;
      this.modalExtension = false;
      this.SelectedDate = true;
      this.checkCreditCard();
    },

    async extensionAvailability() {
      await this.ExtensionController.getExtensionAvailability(
        this.requestsInCheckout.id
      )
        .then(res => {
          this.nextCheckin = res.extend_limit;
          this.modalExtension = true;
          this.allowed = true;
        })
        .catch(error => {
          this.alert(error.body.message, 'error');
          this.allowed = false;
          this.modalExtension = true;
        });
    },

    async additionalValue() {
      let id = this.requestsInCheckout.id; //id da reserva
      let newDate = this.NewCheckout.date_hour; //nova data
      //let activeOffer = this.activePromotion.promotion_recurrent

      await this.ExtensionController.getAdditionalExtensionValue(id, newDate)
        .then(res => {
          this.requestAdditionalValue = res;
          console.log(this.requestAdditionalValue);
        })
        .catch(error => {
          console.log(error);
          this.alert(error.body.message, 'error');
        });
    },

    async extendReservation() {
      let id = this.requestsInCheckout.id; //id da reserva
      let newDate = this.NewCheckout.date_hour; //nova data

      //! Sistema de Frotas não tem pagamento
      // let card = this.cardId; // cartão

      //! Sistema de Frotas não tem promoção
      //let addOffer = this.activePromotion.promotion_recurrent

      this.blockScreen = true;
      await this.ExtensionController.ExtendReservation(id, newDate, null, null)
        .then(res => {
          this.alert(res.message, 'success');
          setTimeout(function() {
            location.reload();
          }, 200);
        })
        .catch(error => {
          this.alert(error.body.message, 'error');
        });
      this.blockScreen = false;
    },

    async checkSchedule() {
      this.requestDate();
      this.extensionAvailability();
    },

    requestDate() {
      this.checkoutDate = this.requestsInCheckout.end_date;
    },

    format(date) {
      return moment(date).format('DD/MM/YYYY');
    },

    formatHour(hour) {
      return moment(hour).format('HH:mm');
    },

    dateNow() {
      const begin = new Date();
      begin.setHours(begin.getHours());
      return moment(begin).toISOString(true);
    },

    info() {
      localStorage.setItem('showInfo', Boolean(true));
      console.log(localStorage.getItem('showInfo'));
      //this.Information.showInfo = localStorage.getItem("showInfo");
      this.$router.push('/user/informacao-reserva');
    },

    close() {
      this.showModalCreditCard = false;

      // Solicita pré-autorização de reservas
      this.VehicleRequestResource.requestPaymentAuthorization(
        localStorage.getItem('pickn_user')
      ).catch(e => {
        this.alert('Erro ao buscar reservas.', 'error');
      });
    },

    mensagemAlerta(objeto) {
      this.alert(objeto.text, objeto.color);
    },

    async intersected() {
      this.getAllVehicleRequests();
    },

    async getConfigurations() {
      let configs = await this.configurationController.getAll(this.client_id);
      this.configurations = configs;
    },

    async checkCreditCard() {
      await this.userController.getUserData().then(async res => {
        await this.creditCardController.getByIdUser().then(
          response => {
            if (response.length >= 1) {
              this.cards = response;
              this.cardId = response[0].id;
              // Verifica se é um cliente de concessionária
            } else if (
              response.length == 0 &&
              res.client.type_client == 'concessionaria'
            ) {
              this.showModalCreditCard = true;
            }
          },
          err => {
            console.log(err);
            this.showModalCreditCard = true;
          }
        );
      });
    },

    totalValue(vr, km, lag) {
      vr = vr == null ? 0 : vr;
      km = km == null ? 0 : km;
      lag = lag == null ? 0 : lag;
      return parseFloat(vr) + parseFloat(km) + parseFloat(lag);
    },

    cancelledItem(items) {
      if (items.step.code == 'cancel' || items.step.code == 'auto-cancel')
        return false;
      return true;
    },
    finishedItem(items) {
      if (items.step.code == 'complete') return true;
      return false;
    },

    alert(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    changePage(change) {
      if (change == 'new') {
        this.showNewRequests = true;
        this.showOldRequests = false;
      } else {
        this.showNewRequests = false;
        this.showOldRequests = true;
      }
    },

    openDetails(vr) {
      this.changeDialog();
      this.vehicleRequestsDetail = vr;
    },

    changeDialog() {
      this.infoRequest = !this.infoRequest;
    },

    async getUser() {
      await this.userController
        .getUserData()
        .then(res => {
          this.user = res.user.id;
        })
        .catch(error => {
          console.log(error);
        });
    },

    cleanVehicleRequests() {
      this.vehicleRequests = [];
      this.vehicleRequestsNext = { page: 1, limit: 5 };
      this.getAllVehicleRequests();
    },

    async getAllVehicleRequests() {
      if (this.vehicleRequestsNext) {
        await this.VehicleRequestResource.getVehicleRequestByUserId(
          this.vehicleRequestsNext.page,
          this.vehicleRequestsNext.limit
        )
          .then(async res => {
            if (res.next) {
              this.vehicleRequestsNext = res.next;
            } else {
              this.vehicleRequestsNext = null;
            }
            this.vehicleRequests = [
              ...this.vehicleRequests,
              ...res.vehicleRequests,
            ];

            await this.getRequestInCheckout();
            await this.getRequestInCheckIn();
          })
          .catch(e => {
            this.alert('Erro ao buscar reservas.', 'error');
          });
      }
    },
    async openChat() {
      await this.userController.getUserData().then(res => {
        zE('webWidget', 'identify', {
          name: res.user.name + '-' + res.client.name,
          email: res.user.email,
          organization: res.client.name,
          phone: res.user.phone,
        });
      });
      this.$zendesk.zE('webWidget', 'open');
    },

    async getRequestInCheckout() {
      this.requestsInCheckout = await this.vehicleRequests.find(
        request => request.step.code === 'check-out'
      );
    },

    async getRequestInCheckIn() {
      let requests = [];

      await this.vehicleRequests.map(request => {
        if (request.step.code === 'check-in') {
          request.allowCheckIn = this.validateTimeCheckIn(request);

          requests.push(request);
        }
      });

      requests.sort((a, b) => {
        if (new Date(a.begin_date).getTime() < new Date(b.begin_date)) {
          return -1;
        }
        return 1;
      });

      this.requestsInCheckIn = requests;
    },

    validateTimeCheckIn(vehicleRequest) {
      let horaAtual = new Date().getTime();
      let horaCheckIn = moment(vehicleRequest.begin_date, 'YYYY-MM-DD HH:mm:ss')
        .toDate()
        .getTime();
      let diferenca = horaCheckIn - horaAtual;
      let timeMin = this.configurations.limit_minutes_before_checkin
        ? 60000 * this.configurations.limit_minutes_before_checkin.value
        : 60000 * Constants.CONFIG_VALUE_MINUTE_MIN_CHECKIN; //quantidade em minutos
      // let timeMax = -60000*Constants.CONFIG_VALUE_MINUTE_MAX_CHECKIN
      // if(diferenca<timeMin && diferenca>timeMax){
      return diferenca < timeMin ? true : false;
    },

    goToCheck(id) {
      this.$router.push({ path: `/user/reserva/${id}` });
    },

    async cancelVehicleRequest() {
      await this.VehicleRequestResource.cancelVehicleRequest(
        this.cancelId,
        this.motiveCancel
      )
        .then(res => {
          this.modalCancel = !this.modalCancel;
          this.motiveCancel = '';
          this.snackbarColor = 'success';
          this.snackbarText = 'Reserva cancelada com sucesso';
          this.snackbar = true;
          this.cleanVehicleRequests();
        })
        .catch(e => {
          this.snackbarColor = 'error';
          this.snackbarText = 'Erro ao cancelar reserva';
          this.snackbar = true;
        });
    },

    openModal(id) {
      this.modalCancel = !this.modalCancel;
      this.cancelId = id;
    },

    async checkTimeCancel(vehicleRequestId) {
      try {
        let vehicleRequest = await this.vehicleRequestController.getById(
          vehicleRequestId
        );
        this.openModal(vehicleRequestId);
      } catch (error) {
        this.$awn.alert(error);
      }
    },

    async openDoors(vehicle_id) {
      await this.vehicleController
        .changeStatus(vehicle_id, 'unlock')
        .then(res => {
          this.responseDoors.mensagem = 'Comando enviado!';
          this.responseDoors.ok = true;
        })
        .catch(e => {
          this.responseDoors.mensagem = 'Falha o enviar comando';
          this.responseDoors.ok = false;
        });
    },

    async closeDoors(vehicle_id) {
      await this.vehicleController
        .changeStatus(vehicle_id, 'lock')
        .then(res => {
          this.responseDoors.mensagem = 'Comando enviado!';
          this.responseDoors.ok = true;
        })
        .catch(e => {
          this.responseDoors.mensagem = 'Falha o enviar comando';
          this.responseDoors.ok = false;
        });
    },
    allowedStep: m => m % 10 === 0,

    openModalRemovePassenger(requestId, id) {
      this.removePassenger.requestId = requestId;
      this.removePassenger.id = id;
      this.modalRemovePassenger = true;
    },
    async removePassengerFunction() {
      await this.VehicleRequestResource.removeSharedRequestPassager(
        this.removePassenger.requestId,
        this.removePassenger.id
      )
        .then(res => {
          this.getRequestPassagers();
          this.removePassenger = {};
          this.modalRemovePassenger = false;
        })
        .catch(e => {
          console.log(e);
        });
    },

    async getRequestPassagers() {
      await this.VehicleRequestResource.requestPassagers()
        .then(res => {
          this.passageiroInCheckIn = res.body;
        })
        .catch(e => {
          console.log(e);
        });
    },

    sharedRequestPassagers(driver, passagers) {
      this.driver = driver;
      this.passagers = passagers;
      this.dialogPassageiro = true;
    },
  },
};
</script>

<style scoped>
.requests-info-button span {
  margin-left: 11px;
  font-size: 14px;
  text-transform: none;
}

.requests-info-button div {
  display: flex;
  align-items: center;
}

.requests-info-button {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px !important;
}

.container {
  position: relative;
  height: 100vh;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.changePage {
  position: fixed;
  top: 48px;
  z-index: 1;
}

.sizeTop {
  height: 48px;
}

.bottom {
  margin-bottom: 60px;
}

.exit {
  position: fixed;
  right: 0;
  top: 0px;
}

.colorSelected {
  color: var(--secondary-color);
}

.colorSelectedBack {
  background-color: var(--secondary-color);
}

.btnColorS {
  background-color: var(--secondary-color) !important;
  color: var(--secondary-color) !important;
}

.btnColor {
  background-color: var(--secondary-color) !important;
}

.btnInfo {
  background-color: white;
}

.float {
  position: absolute;
  color: var(--secondary-color);
  top: 0;
  right: 0;
}

.icon-size {
  font-size: 60px;
}

.icon-info {
  color: var(--secondary-color);
}

.btnGroup {
  margin: 5px;
  color: var(--secondary-color);
  font-weight: 700;
}

.cancelBtn {
  color: #016ea7;
  margin: 5px;
  background-color: #fcfcfc;
}
/* .newRequest {
  margin-top: 96px;
  margin-bottom: 56px;
}

.oldRequest {
  margin-top: 96px;
  margin-bottom: 56px;
} */

.moment {
  margin-bottom: 20px;
}

.vehicle {
  display: flex;
}

.modelo {
  font-size: 16px;
  color: #181f4d;
}

.caption {
  color: #181f4d;
}

.contentLeft {
  display: inline-block;
  width: 60%;
}

.cardContent > hr {
  width: 2px;
  height: 25px;
  margin: auto 0;
}

.contentRight {
  display: inline-block;
  width: 40%;
}

.vehicleImg {
  margin-left: -10px;
}

.cardRadius {
  border-radius: 4px;
}

.border {
  border: 2px solid grey;
}

.borderBottomIn {
  border-bottom: 1px solid var(--secondary-color);
}

.borderBottomOut {
  border-bottom: 1px solid var(--orange-color);
}

.cardContent {
  display: flex;
  justify-content: space-between;
}

.checkin {
  background-color: var(--secondary-color) !important;
  color: #fff;
}

.checkin-text {
  color: var(--secondary-color);
}

.checkout {
  background-color: var(--orange-color) !important;
  color: #fff;
}

.checkout-text {
  color: var(--orange-color);
}

.total {
  color: #181f4d;
}

.carImage {
  border-radius: 6px;
}

.floatBtn {
  position: fixed;
  bottom: 100px;
  right: 4px;
  outline: none;
}

.colorBtn {
  background-color: var(--primary-color) !important;
  color: var(--secondary-color) !important;
  text-decoration: none;
  text-transform: none;
}
.newConteiner {
  padding-left: 40px;
  padding-right: 50px;
  padding-bottom: 10px;
  align-items: center;
}
.float {
  position: absolute;
  top: 8px;
  right: 8px;
}
.primary {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
.newCheckContainer {
  font-size: 25px;
  line-height: 50px;
}
.card-padding {
  padding-left: 16px;
  padding-right: 16px;
}
.backgroundPrimary {
  background-color: var(--primary-color) !important;
  color: var(--secondary-color) !important;
}
.fontPrimary {
  color: var(--primary-color) !important;
}
.fontSecondary {
  color: var(--secondary-color) !important;
}
.rightButtons {
  position: absolute;
  padding-top: 10px;
  right: 0px;
  bottom: 5px;
}
.defaultPadding {
  padding-right: 32px;
  padding-left: 32px;
}
.y-spacing {
  padding-top: 17%;
  padding-bottom: 15%;
}
.info {
  float: right;
  background-color: none;
}
.sharedRequestBtn {
  width: auto;
}
li {
  list-style-type: none;
}
.passageiros {
  display: table;
  margin: 0 auto;
}
.passageirosDesc {
  font-size: 14px;
}
.btnDialog {
  margin-top: 40px;
}
.passageirosImg {
  margin: 10px;
}
.passageirosDiv {
  display: flex;
  align-items: center;
}
.passageiroBtn {
  float: left;
  width: 45%;
  margin-left: 10px;
}
.confirm {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 52px;
  background-color: #55ae6a;
  color: white;
  font-size: 14px;
}
.notification {
  position: absolute;
  width: 100%;
  height: 52px;
  background-color: #55ae6a;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
  left: 0px;
  bottom: 10px;
}
.infoVehicle {
  text-align: center;
  margin: 0 auto;
}
</style>
